import React from "react";
import rightimg from "../../assets/images/newLoginrightImg.png";
import logo from "../../assets/images/krishiMapper.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { NavMenu } from '../Home/NavMenu';
const MasterLogin = () => {
 

    return (
       <> <NavMenu/>
       <div className="mainLogin d-flex align-items-center justify-content-center">
      
      <div className="container">
      <div className="row d-flex justify-content-center">
        <div className="col-md-10">
            <div className="loginSection">
                <div className="row">
                    <div className="col-md-6 p-5">
                       <img src={logo} className="img-fluid newLoginLogo"/>
                        <h2 className="text-center mt-3">Login</h2>
                     <div className="row mt-5">
                        <div className="col-md-12">
                            <label>Select Scheme</label>
                            <select className="form-select">
                                <option>--Selecte Scheme--</option>
                                <option>PDMC</option>
                                <option>NFSM</option>
                            </select>
                        </div>
                        <div className="col-md-12">
                            <label>User Id</label>
                           <input type="text" className="form-control" placeholder="User Id"/>
                        </div>
                        <div className="col-md-12">
                            <label>Password</label>
                            <div class="input-group" id="show_hide_password">
      <input class="form-control" placeholder="Password" type="password"/>
   
    </div>
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            <button className="btn btn-success text-center">Submit</button>
                        </div>
                     </div>
                         </div>
                    <div className="col-md-6"><img src={rightimg} className="img-fluid"/> </div>
                </div>
            </div>
            </div>
       </div>
      </div>
  
       </div>
       <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India. 
</a>
          </div>
        </footer>
       </>
    )

}

export default MasterLogin